import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import { ref } from 'vue';

// TODO: fix type
interface Props {
  data: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RichImagesGrid',
  props: {
    data: null
  },
  setup(__props: any) {



const section = ref(null);

return { __sfc: true,section, CdnImg }
}

})